// status-webapp/src/api/autoruns.ts
import { apiFetch } from "./client";

export interface AutorunCfg {
  id: string; enabled: boolean; schedule: string;
  probe: { stage: string; mode: string; scope: any };
  on_change: { create_run: boolean; triggered_by: string; run_stages: string[] };
  on_no_change?: { log_only: boolean };
  notifications?: { webapp_banner: boolean };
}

export async function listAutoruns(): Promise<AutorunCfg[]> { return apiFetch("/api/autoruns"); }
export async function createAutorun(cfg: AutorunCfg): Promise<AutorunCfg> {
  return apiFetch("/api/autoruns", { method: "POST", body: JSON.stringify(cfg) });
}
export async function updateAutorun(id: string, cfg: AutorunCfg): Promise<AutorunCfg> {
  return apiFetch(`/api/autoruns/${id}`, { method: "PUT", body: JSON.stringify(cfg) });
}
export async function deleteAutorun(id: string): Promise<void> {
  await apiFetch(`/api/autoruns/${id}`, { method: "DELETE" });
}
export async function fireAutorun(id: string): Promise<void> {
  await apiFetch(`/api/autoruns/${id}/fire`, { method: "POST", body: "{}" });
}
